<template>
  <div class="card hoverable" v-if="gridView === 'grid'">
    <div class="card-content">
      <div
        class="date-recieved"
        v-html="$_formatDate(dataContent.date, 'DD MMM, YYYY')"
      ></div>
      <router-link
        class="grey-text text-darken-3 card-title"
        :to="{ name: 'view_item', params: { id: dataContent.id } }"
        v-html="dataContent.title.rendered"
      ></router-link>
      <div class="book-type" v-if="dataContent.acf.entry_type === 'Book'">
        <div class="i-publish-it" v-html="`Publisher: `+cardProps['Publisher']"> </div>
        <div class="i-wrote-it indigo-text text-accent-3" v-html="`Author: `+cardProps['Author']"> </div>
      <div class="isbn-number">ISBN: {{cardProps['ISBN']}}</div>
      </div>
      <div class="judgment-type" v-if="dataContent.acf.entry_type === 'Judgment'">
        Claim No.: {{dataContent.acf.Judgments.claim_no}}
      </div>
      <div class="chip">{{dataContent.acf.entry_type}}</div>      
    </div>
    <div class="card-action">
      <router-link
        :to="{ name: 'view_item', params: { id: dataContent.id } }"
        class="btn-flat waves-effect indigo-text text-accent-4"
      >
        View
      </router-link>
      <button @click="$emit('delete')" class="btn-floating btn-flat btn-small wavess-effect z-depth-0 right">
        <i class="material-icons-outlined grey-text text-darken-3">delete</i>
      </button>
      <div class="clear"></div>
    </div>
  </div>
  <div class="list-item waves-effect" v-else>
    <div class="list-container">
      <span class="list-element">
        <router-link
            class="grey-text text-darken-3 item-title"
            :to="{ name: 'view_item', params: { id: dataContent.id } }"
            v-html="dataContent.title.rendered"
          ></router-link>
          <div
            class="date-recieved"
            v-html="$_formatDate(dataContent.date, 'DD MMM, YYYY')"
          ></div>

      </span>
  
      <div class="support-text">
        {{dataContent.acf.entry_type}}    
      </div>
    </div>
  </div>
</template>
<script>
import {dateFormat} from '@/functions'
export default {
  name: "LibraryCard",
  props: {
    dataContent: {
      type: Object,
    },
    gridView:{
      type: String,
      default: 'grid'
    }
  },
  computed:{
    linkedFile :{
      get () {
        return false
      }
    },
    cardProps:{
      get () {
        let bookObject = () => {
          return {
            "Author" : this.dataContent.acf.book.author,
            "Classification" : this.dataContent.acf.book.classification,
            "Edition" : this.dataContent.acf.book.edition,
            "ISBN" : this.dataContent.acf.book.isbn,
            "Page Count" : this.dataContent.acf.book.page_count,
            "Publication Date" : this.dataContent.acf.book.publication_date,
            "Publisher" : this.dataContent.acf.book.publisher,
            "Series" : this.dataContent.acf.book.series,
            "Year" : this.dataContent.acf.book.year
          }
        }
        return this.dataContent.acf.entry_type === 'Book' ? bookObject() : ''
      }
    }
  },
  methods:{    
		$_formatDate(date, format){
			return dateFormat(new Date(date), format)
    },
  }
}
</script>
<style scoped lang="scss">
.card {
  border-radius: 6px;
  overflow: hidden;
  height: calc(100% - 1.5rem);
  padding-bottom: 48px;
  .card-title {
    font-size: 18px;
    line-height: 1.3;
    font-weight: 400;
    margin: 0px 0 12px 0;
  }
  .date-recieved {
    font-size:12px;
    margin-bottom: 6px;
  }
  .card-content {
    padding: 16px;
    .judgment-type, .book-type {
      margin-bottom: 12px;
    }
  }
  .card-action {
    padding: 16px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    border:none;
  }
  blockquote {
    font-size: 13px;
    padding-left: 8px;
    border-left: 4px solid #304ffe;
    letter-spacing: 1px;
    margin: 7px 2px;
  }
  .chip {
    color:#304ffe;
  }
}
.list-item  {
    background: white;
    width: 100%;
    display: inline-grid;
  .list-container {
      padding: 20px;
      display: flex;
      position: relative;
      align-items: center;
      justify-content: flex-start;
      overflow: hidden;
      .list-element {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        align-self: flex-start;
        .item-title {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            margin-top: 0;
            line-height: normal;
            display: block;
            font-size: 17px;
          }
        .date-recieved {
          white-space: nowrap;
          overflow: hidden;
          margin-top: 4px;
          display: block;
          font-size: 13px;
        }
      }
     
      &:hover {
        background: rgba(0,0,0,0.1)
      }
      .support-text {
        font-size: .875rem;
        line-height: 1.25rem;
        font-weight: 400;
        letter-spacing: .0333333333em;
        text-decoration: inherit;
        text-transform: inherit;
        margin-left: auto;
        margin-right: 0;
      }
  }
}
</style>